import { spaceCategories } from "_constants";
import intersection from "lodash/intersection";
import omit from "lodash/omit";
import { normalize } from "normalizr";
import { combineActions, handleActions } from "redux-actions";
import { spaceSchema, spacesSchema } from "schemas/space";

const withDefaultProps = (space, company, isEdit = false) => ({
  ...space,
  prices: space.prices || [],
  area: space.area || { unit: company.sizeUnit },
  capacity: space.capacity || { unit: spaceCategories[space.category].unit },
  status: space.status || "public",
  isEdit,
});

const spaceReducer = handleActions(
  {
    SPACES_ALL_GET_PENDING: ({ assets }) => ({
      assets: assets.map((a) => ({ ...a, isLoadingSpaces: true })),
    }),

    SPACES_GET_PENDING: ({ assets }, { meta: { spaceIDs } }) => ({
      assets: assets.map((a) =>
        intersection(a.spaceIds, spaceIDs).length ? { ...a, isLoadingSpaces: true } : a
      ),
    }),

    SPACES_GET_FULFILLED: ({ assets, spaces }, { meta: { spaceIDs }, payload }) => ({
      spaces: {
        ...spaces,
        ...normalize(payload.spaces, spacesSchema).entities.spaces,
      },
      assets: assets.map((a) =>
        intersection(a.spaceIds, spaceIDs).length ? { ...a, isLoadingSpaces: false } : a
      ),
    }),

    SPACE_ADD: ({ currentUser, spaces }, { payload: { space } }) => ({
      spaces: {
        0: withDefaultProps(space, currentUser.company, true),
        ...spaces,
      },
    }),

    SPACE_CREATE_FULFILLED: ({ spaces }, { payload: { space } }) => ({
      spaces: {
        ...normalize(space, spaceSchema).entities.spaces,
        ...omit(spaces, 0),
      },
    }),

    SPACE_DELETE_FULFILLED: (state, action) => ({
      spaces: omit(state.spaces, action.meta.spaceID),
    }),

    SPACE_EDIT: ({ currentUser, spaces }, { meta: { spaceID } }) => ({
      spaces: {
        ...spaces,
        [spaceID]: withDefaultProps(spaces[spaceID], currentUser.company, true),
      },
    }),

    SPACE_EDIT_CANCEL: ({ spaces }, { meta: { spaceID } }) => {
      const space = spaceID && spaces[spaceID];

      return {
        spaces: space ? { ...spaces, [spaceID]: { ...space, isEdit: false } } : omit(spaces, 0),
      };
    },
    [combineActions("SPACE_UPDATE", "SPACE_UPDATE_STATUS", "SPACE_UPDATE_UNDER_OFFER")]: {
      FULFILLED: ({ spaces }, { payload: { space } }) => ({
        spaces: { ...spaces, ...normalize(space, spaceSchema).entities.spaces },
      }),
    },

    [combineActions("SPACES_ASSET_GET", "SPACES_ALL_GET", "SPACES_DEAL_GET")]: {
      FULFILLED: ({ spaces }, { payload }) => ({
        spaces: {
          ...spaces,
          ...normalize(payload.spaces, spacesSchema).entities.spaces,
        },
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default spaceReducer;
